import { Component } from '@angular/core';

@Component({
  selector: 'app-utils-action-buttons-skeleton',
  standalone: true,
  templateUrl: './utils-action-buttons-skeleton.component.html',
  styleUrl: './utils-action-buttons-skeleton.component.scss'
})
export class UtilsActionButtonsSkeletonComponent {
  numberOfButtons = new Array(4);
}
